export const planRank = { basic: 0, pro: 1, premium: 2 };

export const hasPlan = (current, minimum = 'pro') =>
  (planRank[current] || 0) >= (planRank[minimum] || 0);

export const productPlanLabel = (plan) => ({
  basic: 'Básico',
  pro: 'Pro',
  premium: 'Premium',
}[plan] || 'Básico');

